module.exports = __webpack_public_path__ + "static/media/insert_drive_file_white_24dp.0b9bd613.svg";